

















import Vue from 'vue'

export default Vue.extend({
  name: 'InfoDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    infoTitle: String,
    infoText: String
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    }
  },

  mounted (): void {
    setTimeout(() => {
      const closeBtn: any = this.$refs['closeBtn']
      if (closeBtn) {
        closeBtn.$el.focus()
      }
    })
  }
})
